import signinMarkRaw from "./signin-card-mark.svg?raw";

// Embedded as a data URI so /brand/ is never a public path.
export const taitoraMarkUri = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(signinMarkRaw)}`;
